import { App, KernelRouteEndpoint, KernelRoute } from "../../../kernel/kernel";
import raf from "raf";

/**
 * Dashboard route
 *
 * @extends KernelRoute
 */
class DashboardRoute extends KernelRoute {

    /**
     * When the user hits the index page, show the index page
     */
    @KernelRouteEndpoint("/contact(/)")
    route (id) {
        System.import("./index").then(View => {
            let opts = {};

            if (undefined !== id) {
                opts.documentId = id;
            }

            const view = new View.default(opts);

            raf(_ => {
                if(undefined !== window && "document" in window) {
                    window.document.body.setAttribute("page-dashboard", true);
                }
            });

            raf(_ => App.contentRegion.show(view));
        });
    }

}

export default DashboardRoute;



// WEBPACK FOOTER //
// ./public/domain/views/contact/contact.route.js